<template>
  <v-container v-if="hasImage" class="phototviewer">
    <v-row>
      <v-col class="mx-3 d-flex justify-center align-center">
        <img class="showselectimage" :src="SelectImage.src" :alt="alt" />
      </v-col>
    </v-row>
    <v-row
      v-show="showDescript"
      v-if="oriDescStyle"
      class="d-flex justify-center"
      style="margin-bottom:2rem;margin-top:2rem"
    >
      <div class="triangle mr-2"></div>
      <span class="ct-text-subtitle3 ct-font-JH">{{
        SelectImage.descript
      }}</span>
    </v-row>
    <v-row
      v-show="showDescript"
      v-else
      class="d-flex justify-center align-center img_des"
      style="margin-bottom:2rem;margin-top:2rem;padding:24px 93px 24px 93px"
    >
      <span class="ct-text-subtitle3 ct-font-JH">{{
        SelectImage.descript
      }}</span>
      <div class="tooltipArrow"></div>
    </v-row>
    <!-- carousels -->
    <v-row class="d-flex justify-center align-center  flex-nowrap">
      <v-col v-if="images.length > 1" cols="1">
        <a
          class="prev sideArrow"
          data-slide="prev"
          tabindex="0"
          title="上一張"
          @keypress.prevent="me(SelectImage.idx, -1)"
          @click.prevent="me(SelectImage.idx, -1)"
        >
          <span class="sect2arrow leftArrow arrow"></span>
          <span class="sr-only">上一張</span>
        </a>
      </v-col>
      <v-col :cols="images.length > 1 ? 10 : 12">
        <div
          class="carouselsImg ma-auto d-flex justify-center align-center"
          style="overflow:hidden"
        >
          <!-- :style="{ width: `${carouselsItemWidth}%` }" -->
          <div
            class="ma-auto carouselsItem d-flex justify-center align-center"
            :style="{
              width: `calc((100% - 60px ) / ${pagination.itemsPerPage} )`
            }"
            v-for="(item, index) in setCarousel(
              images,
              pageStart,
              pagination.itemsPerPage
            )"
            :key="index"
          >
            <img
              :alt="item.descript"
              :class="setHighlight(index)"
              class="imgItem yo"
              :src="item.src"
              tabindex="0"
              :title="item.descript"
              @keypress="me(item.idx, 0)"
              @click="me(item.idx, 0)"
            />
          </div>
        </div>
      </v-col>
      <v-col v-if="images.length > 1" cols="1">
        <a
          class="next sideArrow"
          data-slide="next"
          tabindex="0"
          @keypress.prevent="me(SelectImage.idx, 1)"
          @click.prevent="me(SelectImage.idx, 1)"
        >
          <span class="sect2arrow rightArrow arrow right"></span>
          <span class="sr-only">下一張</span>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  components: {
    // carousel
  },
  props: {
    srcs: {
      type: Array,
      // eslint-disable-next-line no-array-constructor
      default: new Array()
    },
    showcount: {
      type: Number,
      default: 3
    },
    margin: {
      type: Number,
      default: 100
    },
    showDescript: {
      type: Boolean,
      default: false
    },
    oriDescStyle: {
      type: Boolean,
      default: true
    },
    topic: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      prevA: null,
      images: [],
      ComponentId: "",
      SelectImage: "",
      SelectIndex: 0,
      ShowCount: 3,
      Margin: 100,
      descript: {
        type: String,
        default: ""
      },
      pageStart: 0,
      pagination: {
        page: 1,
        pageCount: 0,
        itemsPerPage: 5
      },
      cImages: [],
      hasImage: false
    };
  },
  computed: {
    carouselsItemWidth() {
      return 80 / this.pagination.itemsPerPage;
    },
    alt() {
      return this.topic
        ? `${this.topic}_${this.SelectImage.descript}`
        : this.SelectImage.descript;
    }
  },
  watch: {
    srcs() {
      this.initViewer();
    }
  },
  mounted() {
    this.initViewer();
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    initViewer() {
      // this.images = this.srcs
      if (this.srcs.length > 0) {
        this.pushImg(this.srcs);
        this.ShowCount = this.showcount;
        this.setShowCount();
        this.Margin = this.margin;
        this.ComponentId = "carousel";
        if (this.images.length >= 1) this.SelectIndex = 0;
        this.SelectImage = this.images[this.SelectIndex];
        this.descript = this.srcs[this.SelectIndex].descript;
        this.setHighlight();
        this.hasImage = true;
      } else {
        this.hasImage = false;
      }
      window.onresize = this.setShowCount;
    },
    pushImg(arr) {
      this.images = [];
      for (let i = 0; i < arr.length; i++) {
        this.images.push({
          src: arr[i].src,
          idx: i,
          descript: arr[i].descript
        });
      }
      this.cImages = this.images.map(x => x);
    },
    setAnimate(step) {
      let domList = document.getElementsByClassName("carouselsItem");
      if (domList != null) {
        for (let i = 0; i < domList.length; i++) {
          if (step > 0) {
            domList[i].classList.remove("prev");
            domList[i].classList.add("next");
            setTimeout(() => {
              domList[i].classList.remove("next");
            }, 300);
          } else if (step < 0) {
            domList[i].classList.remove("next");
            domList[i].classList.add("prev");
            setTimeout(() => {
              domList[i].classList.remove("prev");
            }, 300);
          }
        }
      }
    },
    me(index, step) {
      let is = index + step;
      if (is >= 0 && is < this.images.length) {
        if (step != 0) this.setAnimate(is - this.SelectIndex);
        this.pageStart = is;
        this.SelectIndex = is;
        this.SelectImage = this.images[is];
      } else if (is >= this.images.length) {
        this.setAnimate(1);
        is = is - this.images.length;
        this.pageStart = is;
        this.SelectIndex = is;
        this.SelectImage = this.images[is];
      } else if (is < 0) {
        is = this.images.length - 1;
        this.setAnimate(-1);
        this.pageStart = is;
        this.SelectIndex = is;
        this.SelectImage = this.images[is];
      }
      //this.setAnimate();
    },
    setCarousel(arr, si, count) {
      let temp0 = [];
      let temp = [];
      let temp2 = [];
      const beforeC = Math.floor(count / 2);
      const afterC = Math.ceil(count / 2);
      // const beforeC = 0;
      // const afterC = count;

      if (si - beforeC < 0) {
        temp0 = arr
          .slice(arr.length - beforeC + si, arr.length)
          .concat(arr.slice(0, si));
      } else {
        temp0 = arr.slice(si - beforeC, si);
      }

      temp = arr.slice(si, si + afterC);
      const num = temp.length < afterC ? afterC - temp.length : 0;
      temp2 = temp0.concat(temp.concat(arr.slice(0, num)));
      return temp2;
    },
    setShowCount() {
      if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) {
        this.pagination.itemsPerPage = 1;
      } else {
        this.pagination.itemsPerPage = 5;
        if (this.images.length < this.pagination.itemsPerPage) {
          this.pagination.itemsPerPage = this.images.length;
          // if (this.images.length % 2 === 0) {
          //   if (this.images.length !== 0) {
          //     this.pagination.itemsPerPage = this.images.length - 1
          //   } else {
          //     this.pagination.itemsPerPage = 0
          //   }
          // } else if (this.images.length < 5) {
          //   this.pagination.itemsPerPage = this.images.length
          // }
        }
      }
    },
    setHighlight(idx) {
      let b = false;
      if (idx === Math.floor(this.pagination.itemsPerPage / 2)) {
        b = true;
      }
      // if (idx === 0) {
      //   b = true;
      // }
      return {
        hi: b
      };
    }
  }
};
</script>
<style lang="scss" scope>
.phototviewer {
  //background: #eeeeee;
  border-radius: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  font-family: "微軟正黑體";
}
span[id^="carousel_prev"] {
  display: block !important;
}
.photoitem {
  object-fit: cover;
  min-width: 200px;
  min-height: 200px;
  height: 400px;
}
.photobar {
  width: 80%;
  margin-left: 10%;
  margin-top: 20px;
}
.showselectimage {
  object-fit: contain;
  width: 100%;
  height: 100%;
  margin-left: 0;
  min-height: 250px;
  max-height: 45vh;
}
.prev,
.next {
  font-size: 2.5rem;
  font-weight: bolder;
  cursor: pointer;
  // position: absolute;
  // top: calc(50% - 20px);
}
.prev {
  left: 10px;
}
.next {
  right: 10px;
}

.imgItem {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  object-fit: cover;
  height: 115px;
  width: calc(var(--contentWidth) / 1);
  max-width: 250px;
  //margin-bottom: 0px !important;
  @include phone {
    width: calc(var(--contentWidth) / 1);
    height: 90px;
  }
  @include pad {
    width: calc(var(--contentWidth) / 1);
    height: 100px;
  }
}
.leftArrow {
  float: left;
  //background-image: url("~@/assets/images/home/sect5_prev.svg");
}

.rightArrow {
  float: right;
  //background-image: url("~@/assets/images/home/sect5_next.svg");
}

.disabled {
  cursor: not-allowed !important;
}

.sect2arrow {
  color: rgba(1, 1, 1, 0);
  height: 50px;
  width: 50px;
  @include phone {
    height: 25px;
    width: 25px;
  }
  @include pad {
    height: 36px;
    width: 36px;
  }
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  // background-color: rgba(66, 136, 132, 0.7) !important;
  // border-radius: 50% !important;;
  // height:75px !important;;
  // width: 75px !important;;
}

.sideArrow {
  width: 10%;
}

.hi {
  filter: grayscale(0%) !important;
  height: 115px;
  width: calc(var(--contentWidth) / 1);
  //margin-bottom: 0px !important;
  box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
  @include phone {
    width: calc(var(--contentWidth) / 1);
    height: 90px;
  }
  @include pad {
    width: calc(var(--contentWidth) / 1);
    height: 100px;
  }
}
.yo {
  filter: opacity(50%);
  //margin-bottom: 15px;
}

.prevAni {
  position: absolute;
  left: -100px;
  width: 100px;
  height: 100px;
  background: blue;
  -webkit-animation: slideRight 0.5s forwards;
  -webkit-animation-delay: 2s;
  animation: slideRight 0.5s forwards;
  animation-delay: 2s;
}

.nextAni {
  position: absolute;
  right: -100px;
  width: 100px;
  height: 100px;
  background: blue;
  -webkit-animation: slideLeft 0.5s forwards;
  -webkit-animation-delay: 2s;
  animation: slideLeft 0.5s forwards;
  animation-delay: 2s;
}

.carousels {
  --contentWidth: 100%;
}

@keyframes slideLeft {
  100% {
    left: 0;
  }
}
@keyframes slideRight {
  100% {
    left: 0;
  }
}

.triangle {
  width: 21px;
  height: 21px;
  border-style: solid;
  border-width: 0 10.5px 18.2px 10.5px;
  border-color: transparent transparent #91ad70 transparent;
}

.img_des {
  position: relative;
  margin-bottom: 2rem;
  margin-top: 2rem;
  padding: 24px 93px 24px 93px;
  background-color: white;
  border-radius: 60px;
  z-index: 1;
  transform-style: preserve-3d;
  &::before {
    content: "";
    position: absolute;
    top: 1rem;
    left: 0.625rem;
    height: 100%;
    width: 100%;
    border: 2px dashed #9f8d72;
    border-radius: 60px;
    transform: translateZ(-1px);
  }
  .tooltipArrow {
    position: absolute;
    left: 75%;
    top: -10.5px;
    width: 21px;
    height: 21px;
    background-color: white;
    border-radius: 3px;
    transform: rotate(54deg) skewX(20deg) translateZ(-1px);
    transform-style: preserve-3d;
    // border-style: solid;
    // border-width: 0 10.5px 18.2px 10.5px;
    // border-color: transparent transparent white transparent;
    &::before {
      content: "";
      position: absolute;
      top: -8.5px;
      left: 0.625rem;
      height: 100%;
      width: 100%;
      border: 2px dashed #9f8d72;
      border-radius: 3px;
      transform: translateZ(-1px);
    }
  }
}

.prev {
  animation: prev 0.3s;
  transition: all 0.3s;
  opacity: 1;
}
@keyframes prev {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(150%);
    opacity: 1;
  }
}

.next {
  animation: next 0.3s;
  transition: all 0.3s;
  opacity: 1;
}
@keyframes next {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-150%);
    opacity: 1;
  }
}

@keyframes silder {
  3% {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  27% {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  30% {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}
</style>
